import {
  AUTH_LOADED,
  AUTH_LOADING,
  NEW_USER,
  SIGN_IN_USER,
  SIGN_OUT_USER,
} from '../../constants';
import { IReduxAction } from '../../interfaces';

interface IAuthUser {
  uid: string;
  tenantId: string;
  email: string;
  emailVerified: boolean;
  displayName: string;
  photoUrl?: string;
  metadata: {
    creationTime: string;
    lastSignInTime: string;
  };
}

interface IAuthState {
  authenticated: boolean;
  currUser: IAuthUser | null;
  loading: boolean;
  newUser: boolean;
}

const initState: IAuthState = {
  authenticated: false,
  currUser: null,
  loading: true,
  newUser: false,
};

export function authReducer(state = initState, action: IReduxAction) {
  switch (action.type) {
    case AUTH_LOADING:
      return {
        ...state,
        loading: true,
      };

    case AUTH_LOADED:
      return {
        ...state,
        loading: false,
      };

    case NEW_USER:
      return {
        ...state,
        newUser: action.payload,
      };

    case SIGN_IN_USER:
      return {
        ...state,
        authenticated: true,
        currUser: {
          uid: action.payload.uid,
          tenantId: action.payload.tenantId,
          email: action.payload.email,
          emailVerified: action.payload.emailVerified,
          displayName: action.payload.displayName,
          photoUrl: action.payload.photoUrl,
          metadata: action.payload.metadata,
        },
        error: null,
      };

    case SIGN_OUT_USER:
      return {
        ...state,
        authenticated: false,
        currUser: null,
        error: null,
        loading: false,
      };

    default:
      return state;
  }
}
